export const getContentHtml = state => state.payment.contentHtml;
export const getIsPaymentError = state => state.payment.isPaymentError;
export const getTransactionList = state => state.payment.transactionList;
export const getPagination = state => state.payment.pagination;
export const getTransactionTotalRecords = state => state.payment.pagination.totalRecords;
export const getTransactionTotalPages = state => state.payment.pagination.totalPages;
export const getIsLoading = state => state.payment.isLoading;

export const getIsPaymentSuccess = state => state.payment.isPaymentSuccess;
